import React from 'react';
import styled from 'styled-components';

export const InstanceContainer = styled.div`
  background-color: var(--color-beige);
  height: 40px;
  margin-bottom: 1px;
`;

export const InstanceTime = styled.div`
  font-family: BrandonGrotesque-Bold;
  font-size: 14px;
  font-style: italic;
  font-stretch: normal;
  line-height: 40px;
  padding-left: ${(props) => (props.padding ? '0px' : '40px')};
  letter-spacing: normal;
  color: ${(props) => props.color};
`;

export const ClaimNumber = styled.div`
  line-height: 40px;
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  color: #333333;
  cursor: ${(props) => (props.underline ? 'pointer' : 'normal')};
  text-decoration: ${(props) => (props.underline ? 'underline' : '')};
`;

export const WaitlistInfo = styled.div`
  font-size: 12px;
  font-family: BrandonGrotesque-Regular;
  line-height: 40px;
  margin-left: 13px;
  color: #999999;
`;

export const CanceledButton = styled.div`
  width: 85px;
  height: 19px;
  background-color: #999999;
  font-family: BrandonGrotesque-Medium;
  font-size: 12px;
  font-weight: bold;
  font-style: italic;
  text-align: center;
  color: #fafafa;
  line-height: 24px;
  margin-top: 11px;
`;

export const CancelButton = (props) => (
  <svg width="17" height="17" xmlns="http://www.w3.org/2000/svg"
       className={props.right ? 'float-right' : 'none'}
       style={{ cursor: 'pointer', marginRight: '24px', marginTop: '10px' }}>
    <path d="M16.592 14.62a1.394 1.394 0 1 1-1.972 1.972l-6.12-6.12-6.12 6.12A1.394 1.394 0 1 1 .408 14.62l6.12-6.12-6.12-6.12A1.394 1.394 0 1 1 2.38.408l6.12 6.12 6.12-6.12a1.394 1.394 0 1 1 1.972 1.972l-6.12 6.12 6.12 6.12z"
          fill={props.invert ? '#e8e2ce' : '#FFF'}
          fillRule="nonzero"/>
  </svg>
);
